@use "../../styles/text";

// re-use button-style-mixin for most states and types
@use "../../styles/button-style/button-style-mixin";

@use "button-disabled-styles-mixin";

hp6-button-decorator {
  @include button-style-mixin.button-style-mixin;

  @include button-disabled-styles-mixin.button-disabled-styles-mixin;

  // tertiary style is for button type only - not used in call-to-action
  button.tertiary {
    color: var(--color-link-base);
    background: none;
    border: none;

    hp6-icon {
      fill: var(--color-link-base);
    }

    &:hover {
      color: var(--color-link-dark);
      text-decoration: underline;

      hp6-icon {
        fill: var(--color-link-dark);
      }
    }

    &:focus {
      color: var(--color-link-dark);
      text-decoration: underline;

      hp6-icon {
        fill: var(--color-link-dark);
      }
    }

    &:active {
      color: var(--color-link-xdark);
      text-decoration: underline;

      hp6-icon {
        fill: var(--color-link-xdark);
      }
    }

    &.inverted {
      color: var(--color-text-xlight);
      text-decoration: underline;

      hp6-icon {
        fill: var(--color-text-xlight);
      }

      &:hover {
        color: var(--color-text-xlight);
        text-decoration: underline;
        opacity: 0.9;

        hp6-icon {
          fill: var(--color-text-xlight);
        }
      }

      &:focus {
        color: var(--color-text-xlight);
        text-decoration: underline;
        opacity: 0.9;

        hp6-icon {
          fill: var(--color-text-xlight);
        }
      }

      &:active {
        color: var(--color-text-xlight);
        text-decoration: underline;
        opacity: 0.8;

        hp6-icon {
          fill: var(--color-text-xlight);
        }
      }
    }
  }
}
